// composables/useUserMixApi.ts - 聚合用户信息（/usermix/user_info）

export interface MixVipInfo {
  vipType: string
  expireTs: number
}

export interface MixDocTranslatePage {
  pages: number
  expireTs: number
}

export interface MixDocTranslateInfo {
  expireTs: number
  totalPages: number
  pageList: MixDocTranslatePage[]
}

export interface MixUserProfile {
  id: string
  name: string
  avatarUrl: string
  loginType: number
}

export interface UserMixInfoResult {
  profile: MixUserProfile
  vipList: MixVipInfo[]
  docTranslateInfo: MixDocTranslateInfo
}

export function useUserMixApi() {
  const api = useNuxtApp().$api as <T = any>(
    path: string,
    opts?: { method?: string; body?: any }
  ) => Promise<any>

  async function getUserMixInfo(): Promise<UserMixInfoResult> {
    const resp = await api('/usermix/user_info', { method: 'POST', body: {} })
    const d: any = (resp as any)?.data ?? resp

    const user = d?.user_info || {}
    const vipListRaw: any[] = d?.vip_info_list || []
    const perm = d?.permission_info?.doc_translate_info || {}

    const profile: MixUserProfile = {
      id: String(user.uid ?? ''),
      name: String(user.nickname ?? ''),
      avatarUrl: String(user.avatar ?? ''),
      loginType: Number(user.login_type ?? 0)
    }

    const vipList: MixVipInfo[] = vipListRaw.map((x) => ({
      vipType: String(x.vip_type ?? ''),
      expireTs: Number(x.expire_ts ?? 0)
    }))

    const pageList: MixDocTranslatePage[] = (perm.page_list || []).map((p: any) => ({
      pages: Number(p.pages ?? 0),
      expireTs: Number(p.expire_ts ?? 0)
    }))

    const docTranslateInfo: MixDocTranslateInfo = {
      expireTs: Number(perm.expire_ts ?? 0),
      totalPages: Number(perm.total_pages ?? 0),
      pageList
    }

    return { profile, vipList, docTranslateInfo }
  }

  return { getUserMixInfo }
}

